import React from 'react';
import { Reveal } from './Reveal';
type SectionHeadingProps = {
  eyebrow: string;
  title: React.ReactNode;
  subtitle?: string;
  tone?: 'light' | 'dark';
  align?: 'center' | 'left';
};
export function SectionHeading({
  eyebrow,
  title,
  subtitle,
  tone = 'light',
  align = 'center'
}: SectionHeadingProps) {
  const isDark = tone === 'dark';
  return <Reveal className={align === 'center' ? 'mx-auto max-w-3xl text-center' : 'max-w-3xl'} data-id="element-216" data-mp="3k29moe5fil2z">
      <span className={`inline-flex items-center gap-2 rounded-full px-3.5 py-1.5 text-[11px] font-extrabold uppercase tracking-[0.18em] ${isDark ? 'bg-white/10 text-volt' : 'bg-ink text-volt'}`} data-id="element-217" data-mp="gjgi2qump6ky">
        {eyebrow}
      </span>
      <h2 className={`balance mt-6 font-display text-[2.2rem] leading-[0.98] tracking-[-0.01em] sm:text-[3.2rem] ${isDark ? 'text-white' : 'text-ink'}`} data-id="element-218" data-mp="6sc6m145w3uv">
        {title}
      </h2>
      {subtitle && <p className={`mt-5 text-base leading-relaxed sm:text-lg ${isDark ? 'text-white/70' : 'text-ink/70'} ${align === 'center' ? 'mx-auto max-w-2xl' : ''}`} data-id="element-219" data-mp="zb923vrpzhgj">
          {subtitle}
        </p>}
    </Reveal>;
}